import type { Observable, SchedulerLike } from 'rxjs';
import { throwError, timeout } from 'rxjs';
import { catchError, observeOn } from 'rxjs/operators';

export function throwOnTimeout<T>(timeoutMs: number, error: unknown, scheduler?: SchedulerLike) {
  return timeout<T, Observable<never>>({
    each: timeoutMs,
    with() {
      const error$ = throwError(() => error);
      if (scheduler) {
        return error$.pipe(observeOn(scheduler));
      }
      return error$;
    },
    scheduler,
  });
}

export function wrapError<T>(errorWrapper: (error: Error) => Error, scheduler?: SchedulerLike) {
  return catchError<T, Observable<never>>((error: Error) => {
    const error$ = throwError(() => errorWrapper(error));
    if (scheduler) {
      return error$.pipe(observeOn(scheduler));
    }
    return error$;
  });
}
